import supabase from "artifact/supabase";
import Form, { style } from "element/form";
import connected from "standard/connected";
import define from "standard/define";
import filter from "standard/filter";
import on from "standard/on";
import paint from "standard/paint";
import trait from "standard/trait";

@define("m-forgot-password")
class SignUp extends Form {
  @connected
  @paint
  [trait.template]() {
    return `
      <form class='${style.form}' novalidate>
        <m-email class='${style.form__input}'></m-email>
        <button class='${style.form__button}'>Redefinir senha</button>
      </form>
    `;
  }

  @on.submit("form")
  @filter.prevent
  @filter.validity
  @filter.formData
  async [trait.onSubmit]({ email }) {
    const redirectTo =
      "https://harvey.sistemadulino.com.br/oauth/set-new-password";
    const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo,
    });

    error
      ? console.log(error.message)
      : location.assign(`/oauth/check-your-email?email=${email}`);

    return this;
  }
}

export default SignUp;
